/* @flow strict */

/* eslint-disable camelcase */
/* eslint-disable max-params */

import * as React from 'react';
import EventPageDetailCustomersSearchbar from './searchbar';
import EventPageDetailCustomersBody from './body';
import EventPageDetailCustomersPaymentModal from './paymentModal';
import EventPageDetailCustomersPaymentPurchaseModal from './paymentPurchaseModal';
import { EventDetailContainerContext } from '/client/src/contexts/EventDetailContainer';

const EventPageDetailCustomersContent = ({
   menuItems,
   subViewTab,
   eventId,
   handleTriggerChangeTableContent,
   setRowsFilter,
   counter,
   rows,
   rowsOrg,
   setRowsOrg,
   setRows,
   rowsFilter,
   pending,
   showPaymentModal,
   showPaymentPurchaseModal,
   handleShowPaymentModal,
   handleShowPaymentPurchaseModal,
   handleShowPaymentModalOrderId,
   editRow,
   toggleEdit,
   findAndReplaceRowData,
   sponsors,
   showPaymentModalOrderId,
   maxResultCount,
   setMaxResultCount,
   totalRows,
   handlePageChange,
   currentPage,
   handleSearch,
   handleSort
}: any): React.Element<'div'> => {
  const contextEvent = React.useContext(EventDetailContainerContext);

  return (
    <div className="panel panel-default EventPageDetailCustomers">
      <div className="navbar-page-toolbar customers-navbar">
        <div className="container-fluid" style={{ height: '50px' }}>
          <ul className="nav hidden-520">
            {menuItems}
          </ul>

          <ul className="nav">
            <li className="dropdown hide show-520">
              <a
                href="#"
                className="dropdown-toggle"
                data-toggle="dropdown"
                role="button"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i className="icon icon-bars" />
              </a>
              <ul className="dropdown-menu">
                {menuItems}
              </ul>
            </li>
          </ul>
        </div>

        <EventPageDetailCustomersSearchbar
          subViewTab={subViewTab}
          eventId={eventId}
          handleTriggerChangeTableContent={handleTriggerChangeTableContent}
          handleSearch={handleSearch}
          setRowsFilter={setRowsFilter}
          rowsFilter={rowsFilter}
        />
      </div>

      <EventPageDetailCustomersBody
        subViewTab={subViewTab}
        counter={counter}
        data={rows}
        rowsOrg={rowsOrg}
        setRowsOrg={setRowsOrg}
        setRows={setRows}
        rowsFilter={rowsFilter}
        progressPending={pending}
        showPaymentModal={showPaymentModal}
        showPaymentPurchaseModal={showPaymentPurchaseModal}
        handleShowPaymentModal={handleShowPaymentModal}
        handleShowPaymentPurchaseModal={handleShowPaymentPurchaseModal}
        handleShowPaymentModalOrderId={handleShowPaymentModalOrderId}
        editRow={editRow}
        toggleEdit={toggleEdit}
        onHandleFindAndReplaceRowData={findAndReplaceRowData}
        maxResultCount={maxResultCount}
        setMaxResultCount={setMaxResultCount}
        sponsors={sponsors}
        currentPage={currentPage}
        totalRows={totalRows}
        handlePageChange={handlePageChange}
        handleSort={handleSort}
        // resetPaginationToggle={resetPaginationToggle}
      />

      {showPaymentModal &&
      <EventPageDetailCustomersPaymentModal
        isOpen={showPaymentModal}
        handleShowPaymentModal={handleShowPaymentModal}
        showPaymentModalOrderId={showPaymentModalOrderId}
        eventData={contextEvent.eventDetail}
      />
      }

      {showPaymentPurchaseModal &&
      <EventPageDetailCustomersPaymentPurchaseModal
        isOpen={showPaymentPurchaseModal}
        handleShowPaymentPurchaseModal={handleShowPaymentPurchaseModal}
        showPaymentModalOrderId={showPaymentModalOrderId}
      />
      }
    </div>
  );
};

export default EventPageDetailCustomersContent;
